const itemsData = {
  Id: 0,
  boxLines: [
    {
      rowList: [
        { title: "合同号: ", banding: "ContractNo", value: "", className: "c-code-color" },
        {
          title: "成交类型: ",
          banding: "DealType",
          value: "",
          dataType: "Type",
          dataMap: {
            1: "FOB",
            2: "CIF"
          },
          classMap: {
            1: "c-one-color",
            2: "c-two-color"
          }
        }
      ]
    },
    {
      rowList: [
        { title: "订单号: ", banding: "AgentOrderNos", value: "", className: "c-common-color" },
        { title: "合同金额: ", banding: "Amount", value: "", className: "c-amount-color" }
      ]
    },
    {
      rowList: [
        { title: "签署日期:  ", banding: "SignDate", value: "", dataType: "Date" },
        { title: "签署状态:  ", banding: "SignStatus", value: "" }
      ]
    },
    {
      rowList: [{ title: "创建时间: ", banding: "CreatedAt", value: "", dataType: "Date" }]
    },

    {
      rowList: [{ title: "备注：", banding: "Remark", value: "" }]
    }
  ]
};

const itemsDetailData = {
  boxLines: [
    {
      rowList: [
        { title: "货物名称: ", banding: "ProductName", value: "" },
        { title: "型号: ", banding: "PartNo", value: "" },
        { title: "单位: ", banding: "Unit", value: "" }
      ]
    },
    {
      rowList: [
        { title: "数量: ", banding: "Qty", value: "", className: "c-unAmount-color" },
        { title: "单价: ", banding: "UnitPrice", value: "", className: "c-unAmount-color" },
        { title: "金额: ", banding: "Amount", value: "", className: "c-amount-color" }
      ]
    }
  ]
};
export { itemsData, itemsDetailData };
